/*

 _      _       _    _                _
| |    (_)     | |  | |              | |
| |     _ _ __ | | _| |     ___   ___| | _____ _ __
| |    | | '_ \| |/ | |    / _ \ / __| |/ / _ | '__|
| |____| | | | |   <| |___| (_) | (__|   |  __| |
|______|_|_| |_|_|\_|______\___/ \___|_|\_\___|_|

=======================*============================

BlogFooterLinks.js

*/

// Display blog links in static footer
if (document.querySelector('.static-page')) {
  async function getFeedData() {
    let feedData = await fetch('https://linklocker.co/blog/feeds/feed.json')
      .then((response) => response.text())
      .then((data) => {
        return data;
      });

    let feed = JSON.parse(feedData);
    let items = feed.items
      .filter((item) => item.tags !== null)
      .slice(0, 5)
      .map((item) => `<a href="${item.url}">${item.title}</a>`);

    return items;
  }

  (async () => {
    let listItems = await getFeedData();
    let listElements = document.querySelectorAll('#recent-posts li');
    for (let elem in listElements) {
      listElements[elem].innerHTML = listItems[elem];
    }
  })();
}
